export default {
  // If the user is requesting an access token
  connecting: false,
  // If the user is refreshing their token
  reconnecting: false,
  // If the user is connected
  connected:
    !!localStorage.getItem("access_token") &&
    Date.now() < localStorage.expires_at,
  // If the page's content cannot be displayed due to lack of permissions
  denied: true,
  // Responsible for periodically refreshing the access token
  connexionWatch: null,
  // The user's data
  user: JSON.parse(localStorage.getItem("user"))
};
